import React, { useState } from "react";
import OrderPackagesTableRow from "./OrderPackagesTableRow";
import { Table, TableBody } from "@material-ui/core";
import OrderPackagesTableHead from "./OrderPackagesTableHead";
import DriveFileViewerDialog from "../Shared/DriveFileViewerDialog";

const OrderPackagesTable = ({
  packages,
  handleSort,
  selectedPackages,
  setSelectedPackages,
  handleSelectPackage,
  selectedStatus,
}) => {
  // Using a Set to store selected package IDs

  const [singlePackageSelection, setSinglePackageSelection] = useState(null);
  const [openFileViewer, setOpenFileViewer] = useState(false);
  const [openPackageDetails, setOpenPackageDetails] = useState(false);

  const handleOpenFileViewer = (pkg) => {
    setSinglePackageSelection(pkg);
    setOpenFileViewer(true);
  };

  const handleCloseFileViewer = () => {
    setSinglePackageSelection(null);
    setOpenFileViewer(null);
  };

  const handleOpenPackageDetails = (pkg) => {
    setSinglePackageSelection(pkg);
    setOpenPackageDetails(true);
  };

  const handleClosePackageDetails = () => {
    setSinglePackageSelection(null);
    setOpenPackageDetails(null);
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      // If checkbox is checked, select all packages
      setSelectedPackages(new Set(packages.map((pkg) => pkg.id)));
    } else {
      // If checkbox is unchecked, clear all selections
      setSelectedPackages(new Set());
    }
  };

  return (
    <div className="flex-1 overflow-auto">
      {openFileViewer && singlePackageSelection?.fileId && (
        <DriveFileViewerDialog
          open={openFileViewer}
          onClose={handleCloseFileViewer}
          onPrint={() => {}}
          fileId={singlePackageSelection?.fileId}
        />
      )}
      <Table width={"100%"} id="default-material-table">
        <OrderPackagesTableHead
          handleSelectAll={handleSelectAll}
          packages={packages}
          selectedPackages={selectedPackages}
          handleSort={handleSort}
          selectedStatus={selectedStatus}
        />
        <TableBody className="divide-y divide-slate-100">
          {packages.map((pkg, index) => {
            return (
              <OrderPackagesTableRow
                key={index}
                pkg={pkg}
                selectedPackages={selectedPackages}
                onSelectPackage={handleSelectPackage}
                onOpenFileViewer={handleOpenFileViewer}
                onOpenPackageDetails={handleOpenPackageDetails}
                selectedStatus={selectedStatus}
              />
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default OrderPackagesTable;
